import { Navigate } from 'react-router-dom';
import { useSession } from '@/lib/authClient';

interface AuthGuardProps {
  children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { data: session, isPending, error } = useSession();

  console.log('AuthGuard - isPending:', isPending, 'session:', session, 'error:', error);

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!session) {
    console.log('AuthGuard - No session, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
